module.exports = __webpack_public_path__ + "static/CircularPro-Book.588eb6b1.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Book.woff
// module id = 725
// module chunks = 168707334958949